import { IListing } from '@app/models/Listing'
import { ApplicationState } from '@app/store'
import { createSelector } from 'reselect'

export interface IListingPageEditState {
  isLoading: boolean
  isReady: boolean
  isSaving: boolean
  listing: IListing
}
// -------------------------
// SELECTORS
// -------------------------
const selectModuleState = () => (state: ApplicationState) => state.listingEdit

export const selectIsLoading = () =>
  createSelector(selectModuleState(), (mState) => mState.isLoading)

export const selectIsReady = () =>
  createSelector(selectModuleState(), (mState) => mState.isReady)

export const selectIsSaving = () =>
  createSelector(selectModuleState(), (mState) => mState.isSaving)

export const selectListing = () =>
  createSelector(selectModuleState(), (mState) => mState.listing)
